import type { UserRole } from '../../api/types';
import { normalizeIndianPhoneEntry } from '../../utils/phone';

/**
 * What the picker search text prefills in the add-new form: a number (normalised
 * like a typed phone: spaces, +91 and an 11-digit leading 0 removed) becomes the
 * phone, anything else the name (and the company for shippers and vendors).
 */
export function prefillFromSearch(
  search: string,
  role: UserRole,
): { fullName?: string; phone?: string; companyName?: string } {
  const trimmed = search.trim();
  if (!trimmed) return {};
  const digits = normalizeIndianPhoneEntry(trimmed);
  if (/^\d+$/.test(digits)) return { phone: digits };
  return role === 'SHIPPER' || role === 'FLEET_MANAGER'
    ? { fullName: trimmed, companyName: trimmed }
    : { fullName: trimmed };
}
